import { render, staticRenderFns } from "./MemberInvitation.vue?vue&type=template&id=6a88ff89&"
import script from "./MemberInvitation.vue?vue&type=script&lang=js&"
export * from "./MemberInvitation.vue?vue&type=script&lang=js&"
import style0 from "./MemberInvitation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports